// ============================================================
// clientPurges.js — Platform-08 purge-engine bindings.
//
// Backend handlers (admin-clients-purges.js):
//   POST /mgmt/admin/clients/{id}/purges                    propose
//   GET  /mgmt/admin/clients/{id}/purges                    list + live checklist
//   POST /mgmt/admin/clients/{id}/purges/{purgeId}/cancel
//   POST /mgmt/admin/clients/{id}/purges/{purgeId}/commit   { confirmation, handoverConfirmed, handoverNote? }
//
// NOTE paths start '/mgmt/...' — API_BASE_URL already ends '/carehub/api'
// (apiPathConvention.test.js guards this file automatically).
// ============================================================
import { apiGet, apiPost } from './client';

export const listClientPurges = (clientId) => apiGet(`/mgmt/admin/clients/${encodeURIComponent(clientId)}/purges`);

export const proposeClientPurge = (clientId) => apiPost(`/mgmt/admin/clients/${encodeURIComponent(clientId)}/purges`, {});

export const cancelClientPurge = (clientId, purgeId) => apiPost(
  `/mgmt/admin/clients/${encodeURIComponent(clientId)}/purges/${encodeURIComponent(purgeId)}/cancel`, {},
);

export const commitClientPurge = (clientId, purgeId, { confirmation, handoverConfirmed, handoverNote }) => apiPost(
  `/mgmt/admin/clients/${encodeURIComponent(clientId)}/purges/${encodeURIComponent(purgeId)}/commit`,
  { confirmation, handoverConfirmed, handoverNote },
);
